import debounce from "lodash.debounce";

const debouncedSearch = debounce((value, search: (value: any) => void) => {
  search(value);
}, 500);

export const handleFilter = (value: string, search: (value: any) => void) => {
  debouncedSearch(value, search);
};
